export const getCroppedImg = (imageSrc, crop) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = 'Anonymous'; // Ayuda con algunos problemas de CORS
    image.src = imageSrc;

    image.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = crop.width;
      canvas.height = crop.height;

      const ctx = canvas.getContext("2d");
      
      // Para JPEG, establecer fondo blanco ANTES de dibujar la imagen
      if (isJPEG(imageSrc)) {
        ctx.fillStyle = '#FFFFFF';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
      }

      // Dibujar la imagen recortada
      ctx.drawImage(
        image,
        crop.x,
        crop.y,
        crop.width,
        crop.height,
        0,
        0,
        crop.width,
        crop.height
      );

      canvas.toBlob((blob) => {
        if (!blob) return reject(new Error("Error al generar blob"));
        resolve(blob);
      }, isJPEG(imageSrc) ? "image/jpeg" : "image/png", 0.92); // Añadir calidad para JPEG
    };

    image.onerror = () => reject(new Error("Error al cargar imagen"));
  });
};

// Función para detectar si la imagen es JPEG
const isJPEG = (dataUrl) => {
  return dataUrl.startsWith('data:image/jpeg') || 
         dataUrl.startsWith('data:image/jpg');
};

// Función para convertir Blob a Data URL con tipo de imagen correcto
export const blobToDataURL = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};